import React from 'react';

import { ImageCard } from '../../ImageCard';

import styles from './ListTable.Card.module.scss';

export interface IListTableCardProps {
  title: string;
  metadata?: string;
  imageSrc?: string;
  imageAlt?: string;
  titleIcon?: React.ReactNode;
  illustration?: React.ReactNode;
  maxImageHeight?: string;
  href?: string;
  imageOnTop?: boolean;
  isLoading?: boolean;
  maxContentLines?: number;
  dataTest?: string;
  onClick?(): void;
}

export const ListTableCard: React.FC<IListTableCardProps> = ({
  title,
  metadata,
  href,
  imageSrc,
  imageAlt,
  titleIcon,
  illustration,
  imageOnTop,
  isLoading,
  maxImageHeight,
  maxContentLines,
  dataTest,
  onClick
}) => {
  return (
    <ImageCard
      title={title}
      imageSrc={imageSrc}
      imageAlt={imageAlt}
      titleIcon={titleIcon}
      illustration={illustration}
      maxImageHeight={maxImageHeight}
      href={href}
      imageOnTop={imageOnTop}
      isLoading={isLoading}
      loadingImageVariant="large"
      maxContentLines={maxContentLines}
      className={`${styles.listTableCard} ${isLoading ? styles.loadingTableCard : ''}`}
      onClick={onClick}
      dataTest={dataTest}
    >
      {metadata && <ImageCard.Metadata>{metadata}</ImageCard.Metadata>}
    </ImageCard>
  );
};

ListTableCard.displayName = 'ListTableCard';
